import { Col, Container, Row, Image, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";


import "./home.scss";
import React, { useState, useEffect } from "react";
// import { Toggle, ToggleMenu } from "./search_toggle";
import { Example } from "./search_toggle";
import { useDispatch, useSelector } from "react-redux";
import * as appActions from "../../store/app/actions"
import { getAppInfo, getListApps } from "../../store/app/selector"
import { Redirect } from "react-router";


export const Home = () => {
    const { t } = useTranslation('translations');

    const dispath = useDispatch()
    const appInfo = useSelector(state => getAppInfo(state))
    const apps = useSelector(state => getListApps(state))
    const [redirect, setRedirect] = useState(false)

    const onGameClick = (e, item) => {
        e.preventDefault();


        if (!item.active) {
            alert('Coming Soon!')
            return false;
        }
        setRedirect(true)
        dispath(appActions.linkApp(item.gate, item.id, item.apkUrl))
    }

    useEffect(() => {
        // dispath(appActions.getAppLists())
        dispath(appActions.getConfig())
    }, [])

    const Store = ({ item }) => {
        if (item.ios || item.android) {
            return (
                <>
                    {item.ios && <a href={item.iosUrl} className="item ios"></a>}
                    {item.android && <a href={item.androidUrl} className="item android"></a>}
                </>
            )
        }

        return (
            <a href="" className="item laropay"></a>
        )

    }

    if (appInfo && redirect) {

        return (
            <Redirect push to="/dash" />
        );
    }



    return (
        <>
            <div id="game-list">
                <Container>
                    <Example onGameClick={onGameClick} apps={apps} />

                    <h4 className="text-center title">{t('home1')}</h4>
                    <Row className="view-group">
                        {
                            apps.map((item, index) => {
                                return (
                                    <Col key={item + index} className="item col-lg-2 col-md-3 col-sm-4 col-6">
                                        {!item.active && <div className="overlay"></div>}
                                        <div className="title">
                                            <a onClick={(e) => onGameClick(e, item)} href="#">{item.name}</a>
                                            <pre> </pre>
                                        </div>
                                        <div className="thumbnail">

                                            <a href="#" onClick={(e) => onGameClick(e, item)}>
                                                <Image src={item.iconUrl} rounded />
                                            </a>
                                        </div>
                                        <div className="appstore">
                                            <Store item={item} />
                                            {/* <a href="" className="item laropay"></a> */}
                                            {/* <a href="" className="item android"></a> */}
                                        </div>
                                        <Button href={item.apkUrl} className="btn_download">{t('home2')}</Button>
                                    </Col>
                                )
                            })
                        }


                    </Row>

                </Container>
            </div>
        </>
    );
}